import React, { useCallback } from 'react';

import { useDialogs } from '../../../hooks/Dialogs';
import { useAxios } from '../../../hooks/Axios';
import PhoneDialog from '../PhoneDialog';
import { getLocation } from './common';
import { AxiosResponse } from 'axios';
import { AdditionalInformation as AdditionalInformationModel, AditionalInformationResult } from '../../../api/models';

function AdditionalInformation() {
    const { openDialog } = useDialogs();
    const axios = useAxios();

    const phone = useCallback(
        () => new Promise((resolve) => {
            openDialog({
                content: <PhoneDialog onSubmit={resolve} />,
                onClose: () => resolve(undefined)
            });
        }),
        [openDialog]
    );

    const processor = useCallback(
        (response: AxiosResponse) => new Promise<AxiosResponse>((resolve) => {
            //v pripade, ze server vyzaduje doplnujici informace, tak vrati 202 s listkem a typy pozadovanych informaci
            if (response.status === 202) {
                // response.data.type = JSON.parse(response.data.type.replace('location', '"location"').replace('phone', '"phone"'));
                Promise.all(
                    response.data.type.map(async (type: string) => {
                        switch (type) {
                            case 'location':
                                return await getLocation();
                            case 'phone':
                                return await phone();
                            default:
                                console.log(`Unknown additional information type "${type}"!`);
                        }
                    })
                ).then(async (results) => {
                    const body: any = {
                        ticket: response.data.ticket
                    };
                    response.data.type.forEach((type: string, index: number) => body[type] = results[index]);

                    resolve(await axios.post<AdditionalInformationModel>('additionalInformation', body as AditionalInformationResult));
                });
            }
            else {
                resolve(response);
            }
        }),
        [axios, phone]
    );

    return processor;
}

export default AdditionalInformation;
